import script from "./expert.vue?vue&type=script&setup=true&lang=js"
export * from "./expert.vue?vue&type=script&setup=true&lang=js"

import "./expert.vue?vue&type=style&index=0&id=a71c39b4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a71c39b4"]])

export default __exports__